import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ReferenceSkeletonCard } from './reference-skeleton-card';

export function ReferenceSkeletonStructure() {
  return (
    <div
      className={cn(
        'custom-container',
        'grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3',
      )}
    >
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
      <ReferenceSkeletonCard />
    </div>
  );
}
